// extracted by mini-css-extract-plugin
export default {"link":"NavigationLink_link__wo1zu","link--active":"NavigationLink_link--active__IC9xX"};